<!-- Placeholder body rendered inside AppModal from the design-system demos. -->
<template>
  <div class="placeholder flex flex-col items-center justify-center gap-3 rounded-md p-10 text-center">
    <SvgIcon :path="mdiFileDocumentOutline" :size="40" />
    <p class="font-medium">Placeholder</p>
    <p class="text-subtle">Här skulle innehållet (t.ex. en dokumentförhandsvisning) visas.</p>
  </div>
</template>

<script setup lang="ts">
import { mdiFileDocumentOutline } from '@mdi/js'
import { SvgIcon } from '@staff/ui'
</script>

<style scoped lang="scss">
.placeholder {
  border: 1px dashed var(--color-border-default);
  background-color: var(--color-canvas-inset);
}
</style>
